"use client";

import React, { useState } from "react";
import { ArrowLeft, ArrowRight, Clock, Users, Layers, Baby, Cog, Workflow, Wrench, RotateCw, GitBranch, ShieldAlert, SlidersVertical as Sliders, Tag, Crosshair, Sparkles, ChevronRight, Compass, Cpu, Tv, CircleCheck as CheckCircle2, Boxes, CircleQuestionMark as HelpCircle, Lightbulb, Milestone, MonitorOff, Tablet } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Toggle } from "@/components/ui/toggle";
interface SkillItem {
  id: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
  labelVi: string;
  labelEn: string;
  descVi: string;
  descEn: string;
}
const skillsList: SkillItem[] = [{
  id: "crank",
  icon: RotateCw,
  labelVi: "Tay quay",
  labelEn: "Hand Crank",
  descVi: "Cơ chế biến đổi chuyển động quay",
  descEn: "Rotary motion transformation mechanism"
}, {
  id: "linkage",
  icon: GitBranch,
  labelVi: "Thanh truyền",
  labelEn: "Connecting Rod",
  descVi: "Truyền lực và chuyển hướng chuyển động",
  descEn: "Force transmission and motion direction"
}, {
  id: "lifting",
  icon: Sliders,
  labelVi: "Cơ cấu nâng",
  labelEn: "Lifting Mechanism",
  descVi: "Thiết kế đòn bẩy và thanh đỡ nâng hạ",
  descEn: "Lever-based lifting and lowering setups"
}, {
  id: "gripper",
  icon: Wrench,
  labelVi: "Tay gắp",
  labelEn: "Gripper Arm",
  descVi: "Cơ cấu kẹp giữ vật thể chính xác",
  descEn: "Precise object grabbing and holding"
}, {
  id: "launcher",
  icon: Crosshair,
  labelVi: "Cơ cấu bắn",
  labelEn: "Launcher Mechanism",
  descVi: "Tích trữ và giải phóng động năng cơ học",
  descEn: "Kinetic energy loading and release"
}, {
  id: "caterpillar",
  icon: Cog,
  labelVi: "Bánh xích",
  labelEn: "Caterpillar Track",
  descVi: "Hệ truyền động vượt địa hình",
  descEn: "All-terrain continuous track drive"
}, {
  id: "visual-flowchart",
  icon: Workflow,
  labelVi: "Flowchart bằng hình",
  labelEn: "Visual Flowchart",
  descVi: "Biểu diễn logic tuần tự bằng biểu tượng trực quan",
  descEn: "Sequential logic with visual iconography"
}, {
  id: "conditional-loop",
  icon: RotateCw,
  labelVi: "Vòng lặp có điều kiện dừng",
  labelEn: "Conditional Loop",
  descVi: "Lặp lại lệnh cho đến khi đạt tín hiệu dừng",
  descEn: "Repeat commands until stop condition is met"
}, {
  id: "naming-sequence",
  icon: Tag,
  labelVi: "Đặt tên chuỗi lệnh",
  labelEn: "Command Sequence Naming",
  descVi: "Hình thành tư duy hàm và mô đun hóa",
  descEn: "Foundational modular programming concepts"
}, {
  id: "systematic-debug",
  icon: ShieldAlert,
  labelVi: "Debugging có hệ thống",
  labelEn: "Systematic Debugging",
  descVi: "Quy trình kiểm tra, phát hiện và sửa lỗi tuần tự",
  descEn: "Methodical test, detect, and fix routine"
}];
interface PathwayNode {
  code: string;
  nameVi: string;
  nameEn: string;
  imgSrc: string;
  imgSrcset: string;
  imgSizes: string;
  path?: string;
  current?: boolean;
}
const pathwayNodes: PathwayNode[] = [{
  code: "D1",
  nameVi: "Khởi đầu",
  nameEn: "Starter",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d1.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d1.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d1.png-wvc-sizes",
  path: "/RoboticsCourseD1Page"
}, {
  code: "D2",
  nameVi: "Thành phố",
  nameEn: "My City",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d2.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d2.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d2.png-wvc-sizes",
  path: "/RoboticsCourseD2Page"
}, {
  code: "D3",
  nameVi: "Cỗ máy kỳ diệu",
  nameEn: "Wonder Machine",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d3.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d3.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d3.png-wvc-sizes",
  current: true
}, {
  code: "D4",
  nameVi: "Động cơ nhí",
  nameEn: "Little Motors",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d4.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d4.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d4.png-wvc-sizes",
  path: "/RoboticsCourseD4Page"
}, {
  code: "HP1",
  nameVi: "Kỹ sư nhí 1",
  nameEn: "Junior Eng 1",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp1.webp",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp1.webp-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp1.webp-wvc-sizes",
  path: "/RoboticsCourseHP1Page"
}, {
  code: "HP2",
  nameVi: "Kỹ sư nhí 2",
  nameEn: "Junior Eng 2",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp2.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp2.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp2.png-wvc-sizes",
  path: "/RoboticsCourseHP2Page"
}, {
  code: "HP3",
  nameVi: "Cơ điện tử 1",
  nameEn: "Mechatronics 1",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp3.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp3.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp3.png-wvc-sizes",
  path: "/RoboticsCourseHP3Page"
}, {
  code: "HP4",
  nameVi: "Cơ điện tử 2",
  nameEn: "Mechatronics 2",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp4.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp4.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp4.png-wvc-sizes",
  path: "/RoboticsCourseHP4Page"
}, {
  code: "HP5",
  nameVi: "Robotics nâng cao",
  nameEn: "Adv Robotics",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp5.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp5.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp5.png-wvc-sizes",
  path: "/RoboticsCourseHp5Page"
}, {
  code: "HP6",
  nameVi: "Dự án thi đấu",
  nameEn: "Comp Projects",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp6.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp6.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp6.png-wvc-sizes",
  path: "/RoboticsCourseHP6Page"
}];
export default function CourseDetail() {
  const [lang, setLang] = useState<"vi" | "en">("vi");
  const isVi = lang === "vi";
  return <section id="coursedetaild3" data-nav="light" className="bg-background text-foreground py-12 md:py-16 lg:py-20 border-b border-border/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* (1) Four-level Breadcrumbs & Language Switcher */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-6 border-b border-border">
          <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1.5 text-xs sm:text-sm font-medium text-muted-foreground">
            <Link to="/" className="hover:text-primary transition-colors text-foreground">
              {isVi ? "Trang chủ" : "Home"}
            </Link>
            <ChevronRight className="size-3.5 text-muted-foreground shrink-0" />

            <Link to="/RoboticsLearningPathwayPage" className="hover:text-primary transition-colors text-foreground">
              {isVi ? "Lộ trình Robotics" : "Robotics Pathway"}
            </Link>
            <ChevronRight className="size-3.5 text-muted-foreground shrink-0" />

            <Link to="#" className="hover:text-primary transition-colors text-foreground">
              {isVi ? "Robotics 4–6 tuổi" : "Robotics 4–6 Yrs"}
            </Link>
            <ChevronRight className="size-3.5 text-muted-foreground shrink-0" />

            <span className="font-semibold text-primary" aria-current="page">
              {isVi ? "D3 – Cỗ máy kỳ diệu" : "D3 – The Wonder Machine"}
            </span>
          </nav>

          <div className="flex items-center gap-1.5 p-1 rounded-lg bg-muted border border-border shrink-0">
            <Toggle pressed={lang === "vi"} onPressedChange={pressed => {
            if (pressed) setLang("vi");
          }} size="sm" className="text-xs font-semibold px-3 py-1 data-[state=on]:bg-card data-[state=on]:text-foreground shadow-2xs">
              Tiếng Việt
            </Toggle>
            <Toggle pressed={lang === "en"} onPressedChange={pressed => {
            if (pressed) setLang("en");
          }} size="sm" className="text-xs font-semibold px-3 py-1 data-[state=on]:bg-card data-[state=on]:text-foreground shadow-2xs">
              English
            </Toggle>
          </div>
        </div>

        {/* Hero Header for D3 with Top Mechanical Visual */}
        <div className="mt-8 lg:mt-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 space-y-5">
            <div className="flex flex-wrap items-center gap-3">
              <Badge variant="default" className="px-3 py-1 text-sm font-bold bg-primary text-primary-foreground tracking-wide uppercase">
                Course D3
              </Badge>
              <Badge variant="outline" className="px-3 py-1 text-xs font-semibold border-secondary text-secondary-foreground bg-secondary/15">
                {isVi ? "Nền tảng Duplo nâng cao" : "Advanced Duplo Platform"}
              </Badge>
              <Badge variant="outline" className="px-3 py-1 text-xs font-semibold border-border text-muted-foreground">
                {isVi ? "Lứa tuổi: 5–6 tuổi" : "Ages: 5–6 years"}
              </Badge>
            </div>

            <div className="space-y-3">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground font-serif">
                {isVi ? "Cỗ máy kỳ diệu" : "The Wonder Machine"}
              </h1>
              <p className="text-base sm:text-lg text-muted-foreground max-w-3xl leading-relaxed">
                {isVi ? "Khám phá các nguyên lý cơ học phức tạp đầu đời kết hợp thuật toán điều khiển trực quan qua bộ giáo trình Duplo chuyên sâu. Học sinh làm chủ chuỗi liên kết cơ học và sơ đồ khối lưu đồ hình ảnh trước khi bước sang giai đoạn động cơ điện." : "Explore foundational mechanical mechanisms combined with visual sequencing and conditional logic using specialized Duplo kits. Students master linkages and visual flowcharts before transitioning to motorized robotics."}
              </p>
            </div>

            {/* Hero CTAs */}
            <div className="pt-2 flex flex-wrap items-center gap-3.5">
              <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 shadow-sm font-semibold">
                <Link to="/FreeTrialContactPage">
                  <Sparkles className="size-4" />
                  <span>
                    {isVi ? "ĐĂNG KÝ TƯ VẤN" : "BOOK CONSULTATION"}
                  </span>
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold">
                <Link to="/RoboticsLearningPathwayPage">
                  <Compass className="size-4" />
                  <span>
                    {isVi ? "XEM TOÀN BỘ LỘ TRÌNH" : "VIEW FULL PATHWAY"}
                  </span>
                </Link>
              </Button>
            </div>
          </div>

          {/* Top Hero Visual Showcase: Mechanical Linkages & Cranks */}
          <div className="lg:col-span-5 relative rounded-xl overflow-hidden border border-border shadow-md bg-card group">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/duplo_mechanical_linkages_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/duplo_mechanical_linkages_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/duplo_mechanical_linkages_hero.png-wvc-sizes" alt={isVi ? "Cơ chế liên kết cơ học và tay quay từ gạch xây dựng" : "Mechanical linkages and crank mechanism built from large construction bricks"} loading="lazy" className="w-full h-72 sm:h-80 lg:h-[360px] object-cover group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent pointer-events-none" />
            <div className="absolute bottom-3 left-3 right-3 p-3 rounded-lg bg-card/90 backdrop-blur-xs border border-border text-xs flex items-center justify-between shadow-xs">
              <div className="flex items-center gap-2 text-foreground font-semibold">
                <Cog className="size-4 text-primary shrink-0" />
                <span>{isVi ? "Mô hình liên kết cơ học D3" : "D3 Mechanical Linkage Assembly"}</span>
              </div>
              <span className="font-mono text-[10px] text-muted-foreground uppercase">LINKAGE-01</span>
            </div>
          </div>
        </div>

        {/* Specification Metrics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
          <Card className="border border-border/80 shadow-xs bg-card">
            <CardContent className="p-4 sm:p-5 flex items-start gap-3.5">
              <div className="p-2.5 rounded-lg bg-primary/10 text-primary shrink-0">
                <Baby className="size-5" />
              </div>
              <div className="space-y-0.5">
                <span className="text-xs text-muted-foreground uppercase tracking-wide block">
                  {isVi ? "Độ tuổi" : "Age Range"}
                </span>
                <span className="text-base sm:text-lg font-semibold text-foreground">
                  {isVi ? "5–6 tuổi" : "5–6 years"}
                </span>
              </div>
            </CardContent>
          </Card>

          <Card className="border border-border/80 shadow-xs bg-card">
            <CardContent className="p-4 sm:p-5 flex items-start gap-3.5">
              <div className="p-2.5 rounded-lg bg-secondary/15 text-secondary shrink-0">
                <Layers className="size-5" />
              </div>
              <div className="space-y-0.5">
                <span className="text-xs text-muted-foreground uppercase tracking-wide block">
                  {isVi ? "Nền tảng" : "Platform"}
                </span>
                <span className="text-base sm:text-lg font-semibold text-foreground">
                  Duplo
                </span>
              </div>
            </CardContent>
          </Card>

          <Card className="border border-border/80 shadow-xs bg-card">
            <CardContent className="p-4 sm:p-5 flex items-start gap-3.5">
              <div className="p-2.5 rounded-lg bg-accent/20 text-accent shrink-0">
                <Clock className="size-5" />
              </div>
              <div className="space-y-0.5">
                <span className="text-xs text-muted-foreground uppercase tracking-wide block">
                  {isVi ? "Thời lượng" : "Duration"}
                </span>
                <span className="text-base sm:text-lg font-semibold text-foreground">
                  {isVi ? "12 buổi × 90 phút" : "12 sessions × 90 mins"}
                </span>
              </div>
            </CardContent>
          </Card>

          <Card className="border border-border/80 shadow-xs bg-card">
            <CardContent className="p-4 sm:p-5 flex items-start gap-3.5">
              <div className="p-2.5 rounded-lg bg-chart-1/10 text-chart-1 shrink-0">
                <Users className="size-5" />
              </div>
              <div className="space-y-0.5">
                <span className="text-xs text-muted-foreground uppercase tracking-wide block">
                  {isVi ? "Quy mô nhóm" : "Group Size"}
                </span>
                <span className="text-base sm:text-lg font-semibold text-foreground">
                  {isVi ? "2–3 học sinh/bộ kit" : "2–3 students/kit"}
                </span>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* (2) Khóa học này dành cho ai? / Who is this course for? */}
        <div className="mt-14 p-6 sm:p-8 rounded-xl bg-card border border-border shadow-xs">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-secondary">
              <HelpCircle className="size-4" />
              <span>{isVi ? "Đối tượng phù hợp" : "Target Audience"}</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground font-serif">
              {isVi ? "Khóa học này dành cho ai?" : "Who is this course for?"}
            </h2>
            <p className="text-base text-muted-foreground leading-relaxed">
              {isVi ? "Khóa D3 được thiết kế chuyên biệt cho trẻ từ 5–6 tuổi đã hoàn thành khóa D2 hoặc có nền tảng thao tác hình học, sẵn sàng tiếp cận các cơ cấu truyền động phức tạp và làm quen với ngôn ngữ biểu diễn thuật toán sơ đồ hình ảnh (visual flowcharts)." : "Course D3 is tailored for children aged 5–6 who have completed D2 or possess spatial construction basics, advancing into complex mechanical mechanisms and visual flowchart algorithmic representations."}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
              <div className="flex items-start gap-2.5 text-sm text-foreground">
                <CheckCircle2 className="size-4 text-secondary shrink-0 mt-0.5" />
                <span>
                  {isVi ? "Học sinh 5–6 tuổi chuẩn bị bước vào tiểu học" : "Children aged 5–6 transitioning into primary years"}
                </span>
              </div>
              <div className="flex items-start gap-2.5 text-sm text-foreground">
                <CheckCircle2 className="size-4 text-secondary shrink-0 mt-0.5" />
                <span>
                  {isVi ? "Nâng cấp từ mô hình tĩnh D2 sang cơ cấu động lực học" : "Advancing from static D2 structures to kinetic assemblies"}
                </span>
              </div>
              <div className="flex items-start gap-2.5 text-sm text-foreground">
                <CheckCircle2 className="size-4 text-secondary shrink-0 mt-0.5" />
                <span>
                  {isVi ? "Rèn luyện tư duy logic qua lưu đồ thẻ hình không màn hình" : "Building logical thinking via screen-free tangible flowchart cards"}
                </span>
              </div>
              <div className="flex items-start gap-2.5 text-sm text-foreground">
                <CheckCircle2 className="size-4 text-secondary shrink-0 mt-0.5" />
                <span>
                  {isVi ? "Rèn tính kiên nhẫn kiểm tra lỗi (debugging) khi cơ cấu kẹt" : "Fostering patience and systematic debugging when mechanisms jam"}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* (3) 12-Session Structure Timeline */}
        <div className="mt-14 sm:mt-16 space-y-6">
          <div className="space-y-1">
            <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-primary">
              <Milestone className="size-4" />
              <span>{isVi ? "Kế hoạch 12 buổi học" : "12-Session Roadmap"}</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground font-serif">
              {isVi ? "Cấu trúc 12 buổi học" : "12-Session Structure"}
            </h2>
            <p className="text-sm sm:text-base text-muted-foreground">
              {isVi ? "Lộ trình đào tạo được chia thành 5 cụm năng lực tuần tự không phát sinh tên bài học tùy biến:" : "The learning arc is organized into 5 progressive competency milestones:"}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            {/* Phase 1 */}
            <div className="p-5 rounded-xl bg-card border border-border shadow-2xs flex flex-col justify-between">
              <div className="space-y-3">
                <Badge variant="outline" className="border-primary/40 text-primary bg-primary/5">
                  {isVi ? "Buổi 1 – 2" : "Sessions 1 – 2"}
                </Badge>
                <h3 className="font-semibold text-lg text-foreground font-serif">
                  {isVi ? "Khởi động" : "Orientation & Warm-up"}
                </h3>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {isVi ? "Làm quen cấu trúc khung đỡ, điểm tỳ lực và quy tắc an toàn cơ khí cơ bản trong hệ sinh thái Duplo." : "Familiarization with structural chassis, fulcrum points, and workshop safety protocols."}
                </p>
              </div>
              <div className="mt-4 pt-3 border-t border-border/60 text-[11px] font-mono text-muted-foreground">
                PHASE 01 • FOUNDATION
              </div>
            </div>

            {/* Phase 2 */}
            <div className="p-5 rounded-xl bg-card border border-border shadow-2xs flex flex-col justify-between">
              <div className="space-y-3">
                <Badge variant="outline" className="border-secondary text-secondary-foreground bg-secondary/15">
                  {isVi ? "Buổi 3 – 7" : "Sessions 3 – 7"}
                </Badge>
                <h3 className="font-semibold text-lg text-foreground font-serif">
                  {isVi ? "Xây dựng cơ cấu" : "Mechanisms Assembly"}
                </h3>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {isVi ? "Thực hành trực tiếp 5 cơ cấu trụ cột: tay quay, thanh truyền, tay gắp, cơ cấu bắn, bánh xích." : "Hands-on assembly of core mechanisms: hand crank, connecting rod, gripper arm, launcher, and caterpillar tracks."}
                </p>
              </div>
              <div className="mt-4 pt-3 border-t border-border/60 text-[11px] font-mono text-muted-foreground">
                PHASE 02 • MECHANICAL BUILDS
              </div>
            </div>

            {/* Phase 3 */}
            <div className="p-5 rounded-xl bg-card border border-border shadow-2xs flex flex-col justify-between">
              <div className="space-y-3">
                <Badge variant="outline" className="border-accent text-accent-foreground bg-accent/20">
                  {isVi ? "Buổi 8 – 10" : "Sessions 8 – 10"}
                </Badge>
                <h3 className="font-semibold text-lg text-foreground font-serif">
                  {isVi ? "Tư duy thuật toán" : "Algorithmic Thinking"}
                </h3>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {isVi ? "Ứng dụng lưu đồ hình ảnh, lập vòng lặp có điều kiện dừng và kỹ năng đặt tên chuỗi lệnh mô đun." : "Constructing visual flowcharts, conditional repeat loops with exit triggers, and sequence naming."}
                </p>
              </div>
              <div className="mt-4 pt-3 border-t border-border/60 text-[11px] font-mono text-muted-foreground">
                PHASE 03 • VISUAL FLOWCHARTS
              </div>
            </div>

            {/* Phase 4 */}
            <div className="p-5 rounded-xl bg-card border border-border shadow-2xs flex flex-col justify-between">
              <div className="space-y-3">
                <Badge variant="outline" className="border-chart-4 text-chart-4 bg-chart-4/10">
                  {isVi ? "Buổi 11" : "Session 11"}
                </Badge>
                <h3 className="font-semibold text-lg text-foreground font-serif">
                  {isVi ? "Thử nghiệm & debugging" : "Testing & Debugging"}
                </h3>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {isVi ? "Quy trình thử tải cơ học, nhận diện nguyên nhân kẹt khớp và sửa lỗi hệ thống tuần tự." : "Stress-testing assemblies, isolating friction or misalignment points, and iterative debugging."}
                </p>
              </div>
              <div className="mt-4 pt-3 border-t border-border/60 text-[11px] font-mono text-muted-foreground">
                PHASE 04 • SYSTEM DEBUGGING
              </div>
            </div>

            {/* Phase 5 */}
            <div className="p-5 rounded-xl bg-card border border-border shadow-2xs flex flex-col justify-between">
              <div className="space-y-3">
                <Badge variant="outline" className="border-primary text-primary bg-primary/10">
                  {isVi ? "Buổi 12" : "Session 12"}
                </Badge>
                <h3 className="font-semibold text-lg text-foreground font-serif">
                  {isVi ? "Trình bày" : "Capstone Showcase"}
                </h3>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {isVi ? "Báo cáo mô hình thực nghiệm kết hợp giải thích lưu đồ flowchart trước phụ huynh và hội đồng." : "Live demo of physical model paired with step-by-step flowchart presentation."}
                </p>
              </div>
              <div className="mt-4 pt-3 border-t border-border/60 text-[11px] font-mono text-muted-foreground">
                PHASE 05 • PRESENTATION
              </div>
            </div>
          </div>
        </div>

        {/* Mid-Page Visual Showcase: Crank & Lever Mechanism in Action */}
        <div className="mt-14 sm:mt-16 rounded-xl border border-border bg-card p-6 sm:p-8 shadow-md">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-center">
            <div className="lg:col-span-5 space-y-4">
              <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-secondary">
                <RotateCw className="size-4" />
                <span>{isVi ? "Cơ chế hoạt động" : "Kinematics in Action"}</span>
              </div>
              <h3 className="text-2xl font-bold tracking-tight text-foreground font-serif">
                {isVi ? "Cơ cấu Tay quay & Đòn bẩy" : "Crank & Lever Mechanisms"}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {isVi ? "Thực nghiệm trực tiếp cơ chế biến đổi chuyển động quay thành chuyển động tịnh tiến và đòn bẩy nâng hạ. Học sinh dễ dàng quan sát điểm tựa, lực nâng và tỉ số truyền qua các khối gạch cỡ lớn." : "Direct hands-on experimentation transforming rotary motion into linear and lever motion. Students observe fulcrum dynamics, lift force, and mechanical advantage using oversized construction elements."}
              </p>
              <div className="flex flex-wrap gap-2 pt-1">
                <Badge variant="outline" className="border-secondary text-secondary-foreground bg-secondary/15 text-xs">
                  {isVi ? "Biến đổi chuyển động" : "Motion Transformation"}
                </Badge>
                <Badge variant="outline" className="border-primary/40 text-primary bg-primary/5 text-xs">
                  {isVi ? "Tỷ số truyền đòn bẩy" : "Leverage Ratio"}
                </Badge>
              </div>
            </div>
            <div className="lg:col-span-7 relative rounded-xl overflow-hidden border border-border shadow-sm group">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/duplo_crank_lever_mechanism.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/duplo_crank_lever_mechanism.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/duplo_crank_lever_mechanism.png-wvc-sizes" alt={isVi ? "Cơ cấu tay quay và đòn bẩy trong mô hình gạch xây dựng" : "Crank and lever mechanism in action using large construction bricks"} loading="lazy" className="w-full h-64 sm:h-80 object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent pointer-events-none" />
              <div className="absolute top-3 right-3 px-3 py-1 rounded-lg bg-card/90 border border-border text-[11px] font-mono text-foreground font-semibold shadow-xs">
                CRANK-LEVER v2.4
              </div>
            </div>
          </div>
        </div>

        {/* (NEW 1) Equipment Card */}
        <div className="mt-14 sm:mt-16 p-6 sm:p-8 rounded-xl bg-card border border-border shadow-xs">
          <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6 pb-6 border-b border-border/70">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/duplo_robotics_kit.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/duplo_robotics_kit.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/duplo_robotics_kit.png-wvc-sizes" alt="LEGO Duplo STEAM robotics kit used in ROBOTO's D1–D4 foundation track" loading="lazy" className="w-full sm:w-44 h-32 object-cover rounded-lg border border-border shrink-0" />
              <div className="space-y-1.5">
                <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-primary">
                  <Boxes className="size-4" />
                  <span>{isVi ? "Trang thiết bị & Học cụ" : "Learning Equipment & Platform"}</span>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold tracking-tight text-foreground font-serif">
                  {isVi ? "Nền tảng Duplo (LEGO® Education)" : "Duplo (LEGO® Education) Platform"}
                </h3>
                <p className="text-sm text-muted-foreground max-w-2xl leading-relaxed">
                  {isVi ? "Sử dụng bộ học cụ Duplo chuyên dụng từ LEGO® Education với các chi tiết cơ khí an toàn, khớp nối chuẩn xác dành cho lứa tuổi mầm non và tiền tiểu học." : "Utilizes specialized LEGO® Education Duplo kits with child-safe mechanical elements and precise joints tailored for kindergarten and early primary learners."}
                </p>
              </div>
            </div>

            <div className="p-4 sm:p-5 rounded-xl bg-muted/60 border border-border shrink-0 space-y-1.5">
              <div className="text-[11px] font-semibold text-muted-foreground uppercase tracking-wide">
                {isVi ? "Chi phí thiết bị tham khảo" : "Reference Equipment Cost"}
              </div>
              <div className="text-2xl sm:text-3xl font-bold text-primary font-mono">
                ~1.000.000 VNĐ{" "}
                <span className="text-xs font-normal text-muted-foreground font-sans">
                  {isVi ? "/ bộ kit" : "/ kit"}
                </span>
              </div>
              <div className="pt-1">
                <Badge variant="outline" className="border-accent/40 text-accent bg-accent/10 text-[10px] py-0.5">
                  {isVi ? "Chi phí thiết bị tham khảo — không phải học phí" : "Reference equipment cost — not course tuition"}
                </Badge>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 pt-6">
            {/* Specification 1: Computer Requirement */}
            <div className="p-4 rounded-lg bg-background border border-border/80 flex items-start gap-3.5">
              <div className="p-2.5 rounded-lg bg-chart-1/10 text-chart-1 shrink-0 mt-0.5">
                <MonitorOff className="size-5" />
              </div>
              <div className="space-y-1">
                <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground">
                  {isVi ? "Thiết bị máy tính" : "Computer Requirement"}
                </div>
                <div className="text-sm font-bold text-foreground">
                  {isVi ? "KHÔNG yêu cầu máy tính" : "Computer NOT required"}
                </div>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {isVi ? "Trẻ tương tác 100% bằng tay qua mô hình vật lý và thẻ lưu đồ trực quan, hoàn toàn không phụ thuộc màn hình PC/Laptop." : "Students interact 100% physically with mechanical builds and visual flowchart cards, completely screen-free from PC/Laptops."}
                </p>
              </div>
            </div>

            {/* Specification 2: Tablet Optional Supplementary */}
            <div className="p-4 rounded-lg bg-background border border-border/80 flex items-start gap-3.5">
              <div className="p-2.5 rounded-lg bg-secondary/15 text-secondary shrink-0 mt-0.5">
                <Tablet className="size-5" />
              </div>
              <div className="space-y-1">
                <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground">
                  {isVi ? "Thiết bị màn hình bổ trợ" : "Supplementary Screen"}
                </div>
                <div className="text-sm font-bold text-foreground">
                  {isVi ? "Tablet là thiết bị bổ trợ tùy chọn" : "Tablet optional supplementary only"}
                </div>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {isVi ? "Chỉ đóng vai trò thiết bị bổ trợ tùy chọn để tra cứu hình ảnh 3D khi cần thiết, không bắt buộc trong quá trình học tập." : "Serves purely as an optional supplementary display for inspecting 3D assemblies when needed, not required for the course."}
                </p>
              </div>
            </div>

            {/* Specification 3: Platform Standard */}
            <div className="p-4 rounded-lg bg-background border border-border/80 flex items-start gap-3.5 sm:col-span-2 lg:col-span-1">
              <div className="p-2.5 rounded-lg bg-primary/10 text-primary shrink-0 mt-0.5">
                <ShieldAlert className="size-5" />
              </div>
              <div className="space-y-1">
                <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground">
                  {isVi ? "Quy chuẩn học cụ" : "Platform Standard"}
                </div>
                <div className="text-sm font-bold text-foreground">
                  LEGO® Education Duplo
                </div>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {isVi ? "Gạch kích thước lớn an toàn theo tiêu chuẩn quốc tế, cấu trúc bền bỉ cho thao tác lắp ghép đa chiều." : "Oversized child-safe bricks certified under international toy safety standards, built for durable multidirectional building."}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* (NEW 2) Small-Group Learning Model Section */}
        <div className="mt-14 sm:mt-16 space-y-6">
          <div className="space-y-1">
            <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-secondary">
              <Users className="size-4" />
              <span>{isVi ? "Mô hình lớp học" : "Classroom Architecture"}</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground font-serif">
              {isVi ? "HỌC ROBOTICS THEO NHÓM NHỎ" : "SMALL-GROUP ROBOTICS LEARNING"}
            </h2>
            <p className="text-sm sm:text-base text-muted-foreground max-w-3xl">
              {isVi ? "Cả hai mô hình nhóm nhỏ đều đảm bảo thời lượng thực hành trực tiếp tối đa và được tổ chức theo tiêu chuẩn phương pháp sư phạm tương đương:" : "Both small-group configurations ensure ample direct hands-on time and follow equivalent pedagogical standards:"}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Card 1: 2 students/kit (ideal model) */}
            <div className="p-6 sm:p-8 rounded-xl bg-card border border-border shadow-xs flex flex-col justify-between hover:border-primary/40 transition-all">
              <div className="space-y-4">
                <div className="flex items-center justify-between gap-2">
                  <Badge variant="outline" className="border-primary/40 text-primary bg-primary/5 uppercase font-bold text-xs">
                    {isVi ? "Mô hình lý tưởng" : "Ideal Model"}
                  </Badge>
                  <span className="text-xs font-mono text-muted-foreground">RATIO 2:1</span>
                </div>

                <div className="space-y-2">
                  <h3 className="text-xl sm:text-2xl font-bold text-foreground font-serif">
                    {isVi ? "2 học sinh / bộ kit" : "2 students / kit"}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {isVi ? "Hai học sinh đồng hành chặt chẽ: một bạn phụ trách lắp ghép khung máy và một bạn sắp xếp thẻ lưu đồ logic, sau đó đổi vai tuần tự trong từng thử thách." : "Students work in close pairs: one builds the mechanical chassis while the other sequences logic flowchart cards, rotating tasks systematically across challenges."}
                  </p>
                </div>

                <div className="space-y-2.5 pt-3 border-t border-border/60 text-xs sm:text-sm">
                  <div className="flex items-start gap-2.5 text-foreground">
                    <CheckCircle2 className="size-4 text-primary shrink-0 mt-0.5" />
                    <span>
                      {isVi ? "Tập trung cao độ vào từng thao tác lắp ghép chi tiết của cặp đôi" : "High-focus paired collaboration on each mechanical construction step"}
                    </span>
                  </div>
                  <div className="flex items-start gap-2.5 text-foreground">
                    <CheckCircle2 className="size-4 text-primary shrink-0 mt-0.5" />
                    <span>
                      {isVi ? "Thời lượng cầm nắm và thử nghiệm cơ cấu máy được phân bổ trực tiếp 1-1" : "Equally distributed 1-on-1 hands-on manipulation and assembly testing"}
                    </span>
                  </div>
                  <div className="flex items-start gap-2.5 text-foreground">
                    <CheckCircle2 className="size-4 text-primary shrink-0 mt-0.5" />
                    <span>
                      {isVi ? "Giáo viên dễ dàng quan sát và hỗ trợ kỹ thuật sát sao từng bàn học" : "Instructors can maintain immediate observation and tailored mechanical coaching"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="pt-5 mt-6 border-t border-border/60 flex items-center justify-between text-xs text-muted-foreground">
                <span>{isVi ? "Đặc điểm" : "Focus"}: {isVi ? "Tương tác đôi chặt chẽ" : "Close Paired Collaboration"}</span>
                <span className="font-semibold text-primary">{isVi ? "2 học sinh / kit" : "2 students / kit"}</span>
              </div>
            </div>

            {/* Card 2: 3 students/kit (cost-optimized model) */}
            <div className="p-6 sm:p-8 rounded-xl bg-card border border-border shadow-xs flex flex-col justify-between hover:border-secondary/40 transition-all">
              <div className="space-y-4">
                <div className="flex items-center justify-between gap-2">
                  <Badge variant="outline" className="border-secondary text-secondary-foreground bg-secondary/15 uppercase font-bold text-xs">
                    {isVi ? "Mô hình tối ưu chi phí" : "Cost-Optimized Model"}
                  </Badge>
                  <span className="text-xs font-mono text-muted-foreground">RATIO 3:1</span>
                </div>

                <div className="space-y-2">
                  <h3 className="text-xl sm:text-2xl font-bold text-foreground font-serif">
                    {isVi ? "3 học sinh / bộ kit" : "3 students / kit"}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {isVi ? "Ba học sinh vận hành theo cấu trúc nhóm kỹ thuật phân vai: Kỹ sư lắp ráp, Điều phối sơ đồ và Kiểm thử sửa lỗi (debugging). Các vai trò luân chuyển đều đặn mỗi buổi." : "Three students organize into defined engineering roles: Builder, Flowchart Coordinator, and Testing/Debugging Inspector, rotating systematically each session."}
                  </p>
                </div>

                <div className="space-y-2.5 pt-3 border-t border-border/60 text-xs sm:text-sm">
                  <div className="flex items-start gap-2.5 text-foreground">
                    <CheckCircle2 className="size-4 text-secondary shrink-0 mt-0.5" />
                    <span>
                      {isVi ? "Tối ưu hóa chi phí đầu tư thiết bị học cụ cho lớp học và gia đình" : "Optimizes equipment kit investment cost for classrooms and participating families"}
                    </span>
                  </div>
                  <div className="flex items-start gap-2.5 text-foreground">
                    <CheckCircle2 className="size-4 text-secondary shrink-0 mt-0.5" />
                    <span>
                      {isVi ? "Phát triển kỹ năng trao đổi nhóm 3 người và phối hợp chia sẻ tài nguyên" : "Develops triad communication, cooperative resource sharing, and team dynamics"}
                    </span>
                  </div>
                  <div className="flex items-start gap-2.5 text-foreground">
                    <CheckCircle2 className="size-4 text-secondary shrink-0 mt-0.5" />
                    <span>
                      {isVi ? "Mô phỏng chân thực quy trình làm việc tổ nhóm kỹ thuật đa nhiệm vụ" : "Simulates an authentic multi-task engineering project crew workflow"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="pt-5 mt-6 border-t border-border/60 flex items-center justify-between text-xs text-muted-foreground">
                <span>{isVi ? "Đặc điểm" : "Focus"}: {isVi ? "Hiệu quả chi phí & phân vai" : "Cost Efficiency & Role Diversity"}</span>
                <span className="font-semibold text-secondary">{isVi ? "3 học sinh / kit" : "3 students / kit"}</span>
              </div>
            </div>
          </div>
        </div>

        {/* (4) Phương pháp học / Learning Methodology 4-step flow */}
        <div className="mt-14 sm:mt-16 space-y-6">
          <div className="space-y-1">
            <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-secondary">
              <Lightbulb className="size-4" />
              <span>{isVi ? "Phương pháp giảng dạy" : "Pedagogical Framework"}</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground font-serif">
              {isVi ? "Phương pháp học 4 bước" : "4-Step Learning Methodology"}
            </h2>
            <p className="text-sm sm:text-base text-muted-foreground">
              {isVi ? "Mỗi buổi học diễn ra qua chu trình 4 bước chuẩn mực giúp trẻ chủ động khám phá và làm chủ kiến thức:" : "Every 90-minute session executes through a calibrated 4-step cycle:"}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="p-6 rounded-xl bg-card border border-border shadow-xs space-y-3">
              <div className="size-11 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
                <Lightbulb className="size-5" />
              </div>
              <div className="space-y-1">
                <div className="text-xs font-mono font-bold text-primary">STEP 01</div>
                <h3 className="text-lg font-semibold text-foreground font-serif">
                  {isVi ? "Khởi động" : "Warm-up"}
                </h3>
              </div>
              <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                {isVi ? "Đặt vấn đề qua tình huống thực tế đời sống, phân tích cơ chế vật lý đơn giản và mục tiêu buổi học." : "Scenario introduction inspired by real-world machines, discovering mechanical principles."}
              </p>
            </div>

            <div className="p-6 rounded-xl bg-card border border-border shadow-xs space-y-3">
              <div className="size-11 rounded-lg bg-secondary/15 text-secondary flex items-center justify-center">
                <Boxes className="size-5" />
              </div>
              <div className="space-y-1">
                <div className="text-xs font-mono font-bold text-secondary">STEP 02</div>
                <h3 className="text-lg font-semibold text-foreground font-serif">
                  {isVi ? "Lắp ráp" : "Assembly"}
                </h3>
              </div>
              <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                {isVi ? "Chế tạo mô hình thực tế với các cụm cơ cấu tay quay, thanh truyền, tay gắp bằng chi tiết Duplo." : "Constructing tangible mechanical models using Duplo gears, linkages, and structural elements."}
              </p>
            </div>

            <div className="p-6 rounded-xl bg-card border border-border shadow-xs space-y-3">
              <div className="size-11 rounded-lg bg-accent/20 text-accent flex items-center justify-center">
                <Workflow className="size-5" />
              </div>
              <div className="space-y-1">
                <div className="text-xs font-mono font-bold text-accent">STEP 03</div>
                <h3 className="text-lg font-semibold text-foreground font-serif">
                  {isVi ? "Lập trình / tư duy" : "Coding & Logic"}
                </h3>
              </div>
              <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                {isVi ? "Sắp xếp thẻ lệnh sơ đồ flowchart, mô tả quy trình chuyển động và thiết lập vòng lặp điều kiện." : "Arranging visual flowchart blocks, defining sequence conditions, and formulating logical rules."}
              </p>
            </div>

            <div className="p-6 rounded-xl bg-card border border-border shadow-xs space-y-3">
              <div className="size-11 rounded-lg bg-chart-1/10 text-chart-1 flex items-center justify-center">
                <Tv className="size-5" />
              </div>
              <div className="space-y-1">
                <div className="text-xs font-mono font-bold text-chart-1">STEP 04</div>
                <h3 className="text-lg font-semibold text-foreground font-serif">
                  {isVi ? "Trình bày" : "Presentation"}
                </h3>
              </div>
              <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                {isVi ? "Thuyết trình về nguyên lý hoạt động của cỗ máy, chỉ ra cách phát hiện và khắc phục điểm lỗi." : "Presenting machine mechanics, demonstrating flowchart logic, and sharing debug lessons."}
              </p>
            </div>
          </div>
        </div>

        {/* Existing Key Skills Section */}
        <div className="mt-14 sm:mt-16 space-y-6">
          <div className="space-y-1">
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground font-serif">
              {isVi ? "Kỹ năng trọng tâm" : "Key Targeted Skills"}
            </h2>
            <p className="text-sm sm:text-base text-muted-foreground">
              {isVi ? "Bộ 10 năng lực kỹ thuật cơ cấu máy và tư duy khoa học máy tính được chuẩn hóa:" : "The 10 standardized core competencies spanning mechanical mechanisms and algorithmic thinking:"}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3.5 sm:gap-4">
            {skillsList.map((skill, index) => {
            const IconComp = skill.icon;
            return <div key={skill.id} data-index={index} className="group relative p-4 rounded-xl bg-card border border-border shadow-2xs hover:shadow-sm hover:border-primary/50 transition-all flex flex-col justify-between">
                  <div className="space-y-3">
                    <div className="size-10 rounded-lg bg-muted flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                      <IconComp className="size-5" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-base text-foreground leading-snug">
                        {isVi ? skill.labelVi : skill.labelEn}
                      </h3>
                      <p className="text-xs text-muted-foreground mt-1.5 leading-relaxed">
                        {isVi ? skill.descVi : skill.descEn}
                      </p>
                    </div>
                  </div>
                  <div className="pt-3 mt-3 border-t border-border/60 flex items-center justify-between text-[11px] text-muted-foreground font-mono">
                    <span>SKILL #{index + 1}</span>
                    <span className="font-semibold text-foreground/70">D3</span>
                  </div>
                </div>;
          })}
          </div>
        </div>

        {/* (5) Final Project & (6) Platform Equipment Specs */}
        <div className="mt-14 sm:mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* (5) Dự án / sản phẩm cuối khóa / Final Project */}
          <div className="p-6 sm:p-8 rounded-xl bg-card border border-border shadow-xs flex flex-col justify-between">
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <Badge variant="outline" className="border-primary/40 text-primary bg-primary/5 uppercase font-bold text-[11px]">
                  {isVi ? "Dự án cuối khóa" : "Capstone Project"}
                </Badge>
              </div>

              <div className="space-y-2">
                <h3 className="text-xl sm:text-2xl font-bold text-foreground font-serif">
                  {isVi ? "Thuyết trình mô hình & flowchart" : "Model & Flowchart Presentation"}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {isVi ? "Học sinh hoàn thiện nguyên mẫu cánh tay gắp (gripper arm prototype) có thể vận hành kẹp giữ đồ vật qua cơ cấu tay quay - thanh truyền, kết hợp bộ thẻ lưu đồ vật lý (physical flowchart cards) mô tả logic điều khiển từng nhịp chuyển động." : "Students engineer a functional gripper arm prototype capable of picking objects via hand crank-linkage kinematics, paired with physical flowchart cards illustrating every sequential action branch."}
                </p>
              </div>

              <div className="space-y-2 pt-2 border-t border-border/60 text-xs sm:text-sm text-foreground">
                <div className="flex items-center gap-2 text-muted-foreground">
                  <CheckCircle2 className="size-4 text-primary shrink-0" />
                  <span>
                    {isVi ? "Mô hình cơ cấu gắp vật thể có kiểm tra tải trọng" : "Gripper arm prototype tested for load and mechanical stability"}
                  </span>
                </div>
                <div className="flex items-center gap-2 text-muted-foreground">
                  <CheckCircle2 className="size-4 text-primary shrink-0" />
                  <span>
                    {isVi ? "Bảng lưu đồ thẻ hình thể hiện chuỗi lệnh tuần tự & lặp" : "Physical flowchart board displaying sequence & loop operations"}
                  </span>
                </div>
              </div>
            </div>

            <div className="pt-6 mt-4 border-t border-border/60 flex items-center justify-between text-xs text-muted-foreground">
              <span>{isVi ? "Đánh giá bởi" : "Evaluated by"}: Lead Instructor</span>
              <span className="font-semibold text-primary">{isVi ? "Buổi 12" : "Session 12"}</span>
            </div>
          </div>

          {/* (6) Nền tảng / thiết bị / Platform / Equipment spec card */}
          <div className="p-6 sm:p-8 rounded-xl bg-card border border-border shadow-xs flex flex-col justify-between">
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <Badge variant="outline" className="border-secondary text-secondary-foreground bg-secondary/15 uppercase font-bold text-[11px]">
                  {isVi ? "Thiết bị & Nền tảng" : "Equipment & Platform"}
                </Badge>
              </div>

              <div className="space-y-2">
                <h3 className="text-xl sm:text-2xl font-bold text-foreground font-serif">
                  {isVi ? "Nền tảng: Duplo" : "Platform: Duplo"}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {isVi ? "Sử dụng bộ kít Duplo chuyên dụng với gạch cỡ lớn an toàn cho độ tuổi 5–6, tích hợp trục quay, chốt bản lề, bánh răng trợ lực, thanh nối và dây xích bánh xích công nghiệp phiên bản mầm non." : "Employs specialized Duplo engineering kits with child-safe oversized bricks, axle hubs, hinge links, helper gears, and durable pre-school track segments."}
                </p>
              </div>

              <div className="grid grid-cols-2 gap-3 pt-2 border-t border-border/60">
                <div className="p-3 rounded-lg bg-muted/60">
                  <div className="text-[11px] uppercase tracking-wide text-muted-foreground">
                    {isVi ? "Nền tảng chính" : "Primary Platform"}
                  </div>
                  <div className="text-sm font-bold text-foreground mt-0.5">
                    Duplo Robotics
                  </div>
                </div>
                <div className="p-3 rounded-lg bg-muted/60">
                  <div className="text-[11px] uppercase tracking-wide text-muted-foreground">
                    {isVi ? "Giao diện logic" : "Logic Interface"}
                  </div>
                  <div className="text-sm font-bold text-foreground mt-0.5">
                    {isVi ? "Thẻ Flowchart vật lý" : "Physical Cards"}
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-6 mt-4 border-t border-border/60 flex items-center justify-between text-xs text-muted-foreground">
              <span>{isVi ? "Tiêu chuẩn an toàn" : "Safety Spec"}: EN71 / ASTM F963</span>
              <span className="font-semibold text-secondary">100% Screen-free</span>
            </div>
          </div>
        </div>

        {/* (7) Vị trí trong lộ trình / Position in Pathway mini roadmap */}
        <div className="mt-14 sm:mt-16 p-6 sm:p-8 rounded-xl bg-card border border-border shadow-xs space-y-6">
          <div className="space-y-1">
            <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-primary">
              <Compass className="size-4" />
              <span>{isVi ? "Toàn cảnh lộ trình" : "Full Track Overview"}</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground font-serif">
              {isVi ? "Vị trí trong lộ trình Robotics" : "Position in Robotics Pathway"}
            </h2>
            <p className="text-sm sm:text-base text-muted-foreground">
              {isVi ? "D3 là bước chuyển quan trọng kết nối giữa giai đoạn lắp ráp cơ bản và các khóa học lập trình động cơ:" : "D3 represents the pivotal transition connecting foundational building to motorized programmable courses:"}
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-5 lg:grid-cols-10 gap-2.5">
            {pathwayNodes.map((node, i) => {
            if (node.current) {
              return <div key={node.code} data-index={i} className="p-2.5 rounded-lg border-2 border-primary bg-primary/10 text-center flex flex-col justify-between shadow-xs overflow-hidden">
                    <div>
                      <img src={node.imgSrc} data-wvc-srcset={node.imgSrcset} data-wvc-sizes={node.imgSizes} alt={`${node.code} robotics course thumbnail`} loading="lazy" className="w-full h-14 object-cover rounded-md mb-2 border border-primary/30" />
                      <div className="text-xs font-bold text-primary font-mono">{node.code}</div>
                      <div className="text-xs font-bold text-foreground mt-0.5 leading-snug">
                        {isVi ? node.nameVi : node.nameEn}
                      </div>
                    </div>
                    <Badge variant="default" className="mt-2 text-[10px] py-0 px-1.5 mx-auto bg-primary text-primary-foreground">
                      {isVi ? "Đang xem" : "Current"}
                    </Badge>
                  </div>;
            }
            return <Link key={node.code} data-index={i} to={node.path || "/RoboticsLearningPathwayPage"} className="p-2.5 rounded-lg border border-border bg-card hover:border-primary/50 hover:bg-muted/50 text-center flex flex-col justify-between transition-all group overflow-hidden">
                  <div>
                    <img src={node.imgSrc} data-wvc-srcset={node.imgSrcset} data-wvc-sizes={node.imgSizes} alt={`${node.code} robotics course thumbnail`} loading="lazy" className="w-full h-14 object-cover rounded-md mb-2 border border-border group-hover:border-primary/30" />
                    <div className="text-xs font-semibold text-muted-foreground font-mono group-hover:text-primary">
                      {node.code}
                    </div>
                    <div className="text-xs font-medium text-foreground mt-0.5 leading-snug">
                      {isVi ? node.nameVi : node.nameEn}
                    </div>
                  </div>
                  <span className="text-[10px] text-muted-foreground mt-2 block">
                    {isVi ? "Xem khóa" : "View"}
                  </span>
                </Link>;
          })}
          </div>
        </div>

        {/* (9) Bước tiếp theo của con là gì? / What's next for your child? */}
        <div className="mt-14 sm:mt-16 p-6 sm:p-8 rounded-xl bg-primary/5 border border-primary/20 shadow-xs flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="space-y-2 max-w-2xl">
            <Badge variant="outline" className="border-primary text-primary bg-primary/10 font-bold text-[11px] uppercase">
              {isVi ? "Bước tiếp theo của con là gì?" : "What's next for your child?"}
            </Badge>
            <h3 className="text-2xl font-bold tracking-tight text-foreground font-serif">
              {isVi ? "D4 – Động cơ nhí: Chuyển động cùng động cơ điện" : "D4 – Little Motors: Powering Motion with Motors"}
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {isVi ? "Sau khi thành thạo các cơ cấu truyền động cơ học tại D3, con sẽ sẵn sàng tiếp nhận động cơ điện và cảm biến tiếp xúc tại khóa D4 để tự động hóa hoàn toàn các cỗ máy của mình." : "Having mastered kinematic linkages in D3, your child transitions to electric motor drives and touch sensors in D4 to animate their mechanical assemblies."}
            </p>
          </div>

          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shrink-0 font-semibold">
            <Link to="/RoboticsCourseD4Page">
              <span>{isVi ? "Khám phá khóa D4" : "Explore Course D4"}</span>
              <ArrowRight className="size-4" />
            </Link>
          </Button>
        </div>

        {/* Previous & Next Course Navigation */}
        <div className="mt-10 pt-8 border-t border-border flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-4">
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto justify-start sm:justify-center border-border hover:bg-muted">
            <Link to="/RoboticsCourseD2Page">
              <ArrowLeft className="size-4" />
              <span>
                {isVi ? "← D2 — Thành phố của em" : "← D2 — My City"}
              </span>
            </Link>
          </Button>

          <Button asChild variant="default" size="lg" className="w-full sm:w-auto justify-end sm:justify-center bg-primary text-primary-foreground hover:bg-primary/90">
            <Link to="/RoboticsCourseD4Page">
              <span>
                {isVi ? "D4 — Động cơ nhí →" : "D4 — Little Motors →"}
              </span>
              <ArrowRight className="size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}